export default {
  hexToRGBA (hex, opacity) {
    // Удалить символ #, если он есть
    if (hex.charAt(0) === '#') {
      hex = hex.slice(1)
    }

    // Если длина строки HEX равна 3 символам, преобразовать её в 6 символов
    if (hex.length === 3) {
      hex = hex.split('').map(char => char + char).join('')
    }

    // Парсинг значения красного, зеленого и синего цветов из строки HEX
    let r = parseInt(hex.substring(0, 2), 16)
    let g = parseInt(hex.substring(2, 4), 16)
    let b = parseInt(hex.substring(4, 6), 16)

    // Возвращение строки RGBA для CSS
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  },
  adjustHexColor (hex, percent) {
    // Удаление символа #, если он есть
    hex = hex.replace('#', '')

    // Если длина строки HEX равна 3 символам, преобразовать её в 6 символов
    if (hex.length === 3) {
      hex = hex.split('').map(char => char + char).join('')
    }

    // Конвертирование HEX в RGB
    let r = parseInt(hex.substring(0, 2), 16)
    let g = parseInt(hex.substring(2, 4), 16)
    let b = parseInt(hex.substring(4, 6), 16)

    // Вычисление яркости исходного цвета
    let brightness = (r * 299 + g * 587 + b * 114) / 1000

    // Определение, делать ли цвет темнее или светлее
    let adjust = brightness < 128 ? (100 - percent) / 100 : percent / 100

    // Подстройка значений RGB
    r = Math.round(r * adjust)
    g = Math.round(g * adjust)
    b = Math.round(b * adjust)

    // Ограничение значений между 0 и 255
    r = Math.min(255, Math.max(0, r))
    g = Math.min(255, Math.max(0, g))
    b = Math.min(255, Math.max(0, b))

    // Конвертация обратно в HEX и добавление недостающих нулей
    r = r.toString(16).padStart(2, '0')
    g = g.toString(16).padStart(2, '0')
    b = b.toString(16).padStart(2, '0')

    return `#${r}${g}${b}`
  },
}
